export default __webpack_public_path__ + "static/media/quicargo.e9f0f786.png";